/*
 * Generated from the pre-visual-refresh design tokens, do not edit by hand.
 *
 * The visual refresh values are the generated design token base since
 * APPDEV-19979. These are the values the tokens had before that, kept so a
 * consumer can opt back out of the refresh. Only tokens whose value actually
 * changed are listed. Once the opt-out is dropped, this whole file goes with it.
 */

/**
 * Pre-refresh design token values — light mode.
 */
export const classicLightOverrides = {
  '--dt-box-shadows-surface-flat-rest': '0px 0px 0px 1px #2d2e4e0d',
  '--dt-box-shadows-surface-flat-hover':
    '0px 0px 0px 1px #2d2e4e08, 0px 1px 2px #2d2e4e0d, 0px 4px 8px -2px #2d2e4e12',
  '--dt-box-shadows-surface-flat-active': '0px 0px 0px 1px #2d2e4e0d',
  '--dt-box-shadows-surface-flat-drag':
    '0px 0px 0px 1px #2d2e4e08, 0px 1px 2px #2d2e4e0d, 0px 7px 17px -2px #2d2e4e52',
  '--dt-box-shadows-surface-raised-rest':
    '0px 0px 0px 1px #2d2e4e08, 0px 1px 2px #2d2e4e0d, 0px 4px 8px -2px #2d2e4e12',
  '--dt-box-shadows-surface-raised-hover':
    '0px 0px 0px 1px #2d2e4e08, 0px 1px 2px #2d2e4e0d, 0px 5px 11px -2px #2d2e4e29',
  '--dt-box-shadows-surface-raised-active':
    '0px 0px 0px 1px #2d2e4e08, 0px 1px 2px #2d2e4e0d, 0px 4px 8px -2px #2d2e4e12',
  '--dt-box-shadows-surface-raised-drag':
    '0px 0px 0px 1px #2d2e4e08, 0px 1px 2px #2d2e4e0d, 0px 7px 17px -2px #2d2e4e52',
  '--dt-box-shadows-surface-floating-rest':
    '0px 0px 0px 1px #2d2e4e08, 0px 1px 2px #2d2e4e0d, 0px 5px 11px -2px #2d2e4e29',
  '--dt-box-shadows-surface-floating-hover':
    '0px 0px 0px 1px #2d2e4e08, 0px 1px 2px #2d2e4e0d, 0px 6px 14px -2px #2d2e4e3d',
  '--dt-box-shadows-surface-floating-active':
    '0px 0px 0px 1px #2d2e4e08, 0px 1px 2px #2d2e4e0d, 0px 5px 11px -2px #2d2e4e29',
  '--dt-box-shadows-surface-floating-drag':
    '0px 0px 0px 1px #2d2e4e08, 0px 1px 2px #2d2e4e0d, 0px 7px 17px -2px #2d2e4e52',
  '--dt-box-shadows-field-neutral-emphasized-rest':
    'inset 0px 0px 0px 1px #2f2f4f1f, inset 0px -1px 0px #2f2f4f14, 0px 1px 1px -1px #2d2e4e1f, inset 0px 0px 0px 1px #fff',
  '--dt-box-shadows-field-neutral-emphasized-hover':
    'inset 0px 0px 0px 1px #2f2f4f1f, inset 0px -1px 0px #2f2f4f14, 0px 1px 1px -1px #2d2e4e1f, inset 0px 0px 0px 1px #dadbe4',
  '--dt-box-shadows-field-neutral-emphasized-active':
    'inset 0px 0px 0px 1px #2f2f4f1f, inset 0px -1px 0px #2f2f4f14, 0px 1px 1px -1px #2d2e4e1f, inset 0px 0px 0px 1px #d0d1dc',
  '--dt-box-shadows-field-neutral-accent':
    'inset 0px 0px 0px 1px #0000004d, inset 0px -1px 0px #0000008c, 0px 1px 1px -1px #2d2e4e1f',
  '--dt-box-shadows-field-neutral-disabled':
    'inset 0px 0px 0px 1px #2f2f4f0f, inset 0px -1px 0px #2f2f4f0a, 0px 1px 1px -1px #2d2e4e1f',
  '--dt-box-shadows-field-primary-emphasized-rest':
    'inset 0px 0px 0px 1px #250f980f, inset 0px -1px 0px #250f981a, 0px 1px 1px -1px #2d2e4e1f, inset 0px 0px 0px 1px #e1e5f7',
  '--dt-box-shadows-field-primary-emphasized-hover':
    'inset 0px 0px 0px 1px #250f980f, inset 0px -1px 0px #250f981a, 0px 1px 1px -1px #2d2e4e1f, inset 0px 0px 0px 1px #d5dbf6',
  '--dt-box-shadows-field-primary-emphasized-active':
    'inset 0px 0px 0px 1px #250f980f, inset 0px -1px 0px #250f981a, 0px 1px 1px -1px #2d2e4e1f, inset 0px 0px 0px 1px #c9d1f4',
  '--dt-box-shadows-field-primary-accent':
    'inset 0px 0px 0px 1px #250f9833, inset 0px -1px 0px #250f984d, 0px 1px 1px -1px #2d2e4e1f',
  '--dt-box-shadows-field-primary-disabled':
    'inset 0px 0px 0px 1px #2f2f4f0f, inset 0px -1px 0px #2f2f4f0a, 0px 1px 1px -1px #2d2e4e1f',
  '--dt-box-shadows-field-success-emphasized-rest':
    'inset 0px 0px 0px 1px #003b360f, inset 0px -1px 0px #003b361a, 0px 1px 1px -1px #2d2e4e1f, inset 0px 0px 0px 1px #e0e7e6',
  '--dt-box-shadows-field-success-emphasized-hover':
    'inset 0px 0px 0px 1px #003b360f, inset 0px -1px 0px #003b361a, 0px 1px 1px -1px #2d2e4e1f, inset 0px 0px 0px 1px #d3dedd',
  '--dt-box-shadows-field-success-emphasized-active':
    'inset 0px 0px 0px 1px #003b360f, inset 0px -1px 0px #003b361a, 0px 1px 1px -1px #2d2e4e1f, inset 0px 0px 0px 1px #c7d5d3',
  '--dt-box-shadows-field-success-accent':
    'inset 0px 0px 0px 1px #003b3626, inset 0px -1px 0px #003b364d, 0px 1px 1px -1px #2d2e4e1f',
  '--dt-box-shadows-field-success-disabled':
    'inset 0px 0px 0px 1px #2f2f4f0f, inset 0px -1px 0px #2f2f4f0a, 0px 1px 1px -1px #2d2e4e1f',
  '--dt-box-shadows-field-warning-emphasized-rest':
    'inset 0px 0px 0px 1px #512a000f, inset 0px -1px 0px #512a001a, 0px 1px 1px -1px #2d2e4e1f, inset 0px 0px 0px 1px #f9f0e5',
  '--dt-box-shadows-field-warning-emphasized-hover':
    'inset 0px 0px 0px 1px #512a000f, inset 0px -1px 0px #512a001a, 0px 1px 1px -1px #2d2e4e1f, inset 0px 0px 0px 1px #f9ebdb',
  '--dt-box-shadows-field-warning-emphasized-active':
    'inset 0px 0px 0px 1px #512a000f, inset 0px -1px 0px #512a001a, 0px 1px 1px -1px #2d2e4e1f, inset 0px 0px 0px 1px #f9e6d0',
  '--dt-box-shadows-field-warning-accent':
    'inset 0px 0px 0px 1px #512a001a, inset 0px -1px 0px #512a0033, 0px 1px 1px -1px #2d2e4e1f',
  '--dt-box-shadows-field-warning-disabled':
    'inset 0px 0px 0px 1px #2f2f4f0f, inset 0px -1px 0px #2f2f4f0a, 0px 1px 1px -1px #2d2e4e1f',
  '--dt-box-shadows-field-critical-emphasized-rest':
    'inset 0px 0px 0px 1px #7500130f, inset 0px -1px 0px #7500131a, 0px 1px 1px -1px #2d2e4e1f, inset 0px 0px 0px 1px #f8e1e1',
  '--dt-box-shadows-field-critical-emphasized-hover':
    'inset 0px 0px 0px 1px #7500130f, inset 0px -1px 0px #7500131a, 0px 1px 1px -1px #2d2e4e1f, inset 0px 0px 0px 1px #f6d6d5',
  '--dt-box-shadows-field-critical-emphasized-active':
    'inset 0px 0px 0px 1px #7500130f, inset 0px -1px 0px #7500131a, 0px 1px 1px -1px #2d2e4e1f, inset 0px 0px 0px 1px #f5cac9',
  '--dt-box-shadows-field-critical-accent':
    'inset 0px 0px 0px 1px #75001333, inset 0px -1px 0px #7500134d, 0px 1px 1px -1px #2d2e4e1f',
  '--dt-box-shadows-field-critical-disabled':
    'inset 0px 0px 0px 1px #2f2f4f0f, inset 0px -1px 0px #2f2f4f0a, 0px 1px 1px -1px #2d2e4e1f',
  '--dt-colors-theme-foreground-10': '#2d2e4e',
  '--dt-colors-theme-background-10': '#f9f9fa',
  '--dt-colors-theme-background-shell-default': '#f2f2f5',
  '--dt-colors-theme-background-surface-backdrop-embedded': '#f9f9facc',
  '--dt-colors-theme-neutral-10': '#f2f2f5',
  '--dt-colors-theme-neutral-20': '#ebecf0',
  '--dt-colors-theme-neutral-30': '#e4e5eb',
  '--dt-colors-theme-neutral-40': '#dadbe4',
  '--dt-colors-theme-neutral-50': '#d0d1dc',
  '--dt-colors-theme-neutral-60': '#c6c7d5',
  '--dt-colors-theme-neutral-70': '#5b5c81',
  '--dt-colors-theme-neutral-80': '#4d4e72',
  '--dt-colors-theme-neutral-90': '#404164',
  '--dt-colors-theme-primary-10': '#f1f2f9',
  '--dt-colors-theme-primary-20': '#e9ecf8',
  '--dt-colors-theme-primary-30': '#e1e5f7',
  '--dt-colors-theme-primary-40': '#d5dbf6',
  '--dt-colors-theme-primary-50': '#c9d1f4',
  '--dt-colors-theme-primary-60': '#bdc7f2',
  '--dt-colors-theme-primary-70': '#474fcf',
  '--dt-colors-theme-primary-80': '#3b3fbe',
  '--dt-colors-theme-primary-90': '#312dad',
  '--dt-colors-theme-success-10': '#f1f3f3',
  '--dt-colors-theme-success-20': '#e8eded',
  '--dt-colors-theme-success-30': '#e0e7e6',
  '--dt-colors-theme-success-40': '#d3dedd',
  '--dt-colors-theme-success-50': '#c7d5d3',
  '--dt-colors-theme-success-60': '#bbccc9',
  '--dt-colors-theme-success-70': '#2f6862',
  '--dt-colors-theme-success-80': '#1f5a54',
  '--dt-colors-theme-success-90': '#0d4c47',
  '--dt-colors-theme-warning-10': '#f9f6f3',
  '--dt-colors-theme-warning-20': '#f9f3ec',
  '--dt-colors-theme-warning-30': '#f9f0e5',
  '--dt-colors-theme-warning-40': '#f9ebdb',
  '--dt-colors-theme-warning-50': '#f9e6d0',
  '--dt-colors-theme-warning-60': '#f9e1c6',
  '--dt-colors-theme-warning-70': '#eea53c',
  '--dt-colors-theme-warning-80': '#ffb54f',
  '--dt-colors-theme-warning-90': '#ffc76d',
  '--dt-colors-theme-critical-10': '#f9f1f2',
  '--dt-colors-theme-critical-20': '#f8e9e9',
  '--dt-colors-theme-critical-30': '#f8e1e1',
  '--dt-colors-theme-critical-40': '#f6d6d5',
  '--dt-colors-theme-critical-50': '#f5cac9',
  '--dt-colors-theme-critical-60': '#f3bebd',
  '--dt-colors-theme-critical-70': '#c62239',
  '--dt-colors-theme-critical-80': '#b4002b',
  '--dt-colors-theme-critical-90': '#a2001d',
  '--dt-colors-background-base-default': '#f9f9fa',
  '--dt-colors-background-surface-backdrop': '#f9f9facc',
  '--dt-colors-background-surface-backdrop-embedded': '#f9f9facc',
  '--dt-colors-background-container-neutral-subdued': '#f9f9fa',
  '--dt-colors-background-container-neutral-default': '#f2f2f5',
  '--dt-colors-background-container-neutral-emphasized': '#ebecf0',
  '--dt-colors-background-container-neutral-accent': '#5b5c81',
  '--dt-colors-background-container-primary-default': '#f1f2f9',
  '--dt-colors-background-container-primary-emphasized': '#e9ecf8',
  '--dt-colors-background-container-primary-accent': '#474fcf',
  '--dt-colors-background-container-success-default': '#f1f3f3',
  '--dt-colors-background-container-success-emphasized': '#e8eded',
  '--dt-colors-background-container-success-accent': '#2f6862',
  '--dt-colors-background-container-warning-default': '#f9f6f3',
  '--dt-colors-background-container-warning-emphasized': '#f9f3ec',
  '--dt-colors-background-container-warning-accent': '#eea53c',
  '--dt-colors-background-container-critical-default': '#f9f1f2',
  '--dt-colors-background-container-critical-emphasized': '#f8e9e9',
  '--dt-colors-background-container-critical-accent': '#c62239',
  '--dt-colors-background-field-neutral-disabled': '#e4e5eb80',
  '--dt-colors-background-field-neutral-default': '#e4e5eb00',
  '--dt-colors-background-field-neutral-default-hover': '#dadbe4',
  '--dt-colors-background-field-neutral-default-active': '#d0d1dc',
  '--dt-colors-background-field-neutral-emphasized': '#e4e5eb',
  '--dt-colors-background-field-neutral-emphasized-hover': '#dadbe4',
  '--dt-colors-background-field-neutral-emphasized-active': '#d0d1dc',
  '--dt-colors-background-field-neutral-accent': '#5b5c81',
  '--dt-colors-background-field-neutral-accent-hover': '#4d4e72',
  '--dt-colors-background-field-neutral-accent-active': '#404164',
  '--dt-colors-background-field-primary-disabled': '#e4e5eb80',
  '--dt-colors-background-field-primary-default': '#e1e5f700',
  '--dt-colors-background-field-primary-default-hover': '#d5dbf6',
  '--dt-colors-background-field-primary-default-active': '#c9d1f4',
  '--dt-colors-background-field-primary-emphasized': '#e1e5f7',
  '--dt-colors-background-field-primary-emphasized-hover': '#d5dbf6',
  '--dt-colors-background-field-primary-emphasized-active': '#c9d1f4',
  '--dt-colors-background-field-primary-accent': '#474fcf',
  '--dt-colors-background-field-primary-accent-hover': '#3b3fbe',
  '--dt-colors-background-field-primary-accent-active': '#312dad',
  '--dt-colors-background-field-success-disabled': '#e4e5eb80',
  '--dt-colors-background-field-success-default': '#e0e7e600',
  '--dt-colors-background-field-success-default-hover': '#d3dedd',
  '--dt-colors-background-field-success-default-active': '#c7d5d3',
  '--dt-colors-background-field-success-emphasized': '#e0e7e6',
  '--dt-colors-background-field-success-emphasized-hover': '#d3dedd',
  '--dt-colors-background-field-success-emphasized-active': '#c7d5d3',
  '--dt-colors-background-field-success-accent': '#2f6862',
  '--dt-colors-background-field-success-accent-hover': '#1f5a54',
  '--dt-colors-background-field-success-accent-active': '#0d4c47',
  '--dt-colors-background-field-warning-disabled': '#e4e5eb80',
  '--dt-colors-background-field-warning-default': '#f9f0e500',
  '--dt-colors-background-field-warning-default-hover': '#f9ebdb',
  '--dt-colors-background-field-warning-default-active': '#f9e6d0',
  '--dt-colors-background-field-warning-emphasized': '#f9f0e5',
  '--dt-colors-background-field-warning-emphasized-hover': '#f9ebdb',
  '--dt-colors-background-field-warning-emphasized-active': '#f9e6d0',
  '--dt-colors-background-field-warning-accent': '#eea53c',
  '--dt-colors-background-field-warning-accent-hover': '#ffb54f',
  '--dt-colors-background-field-warning-accent-active': '#ffc76d',
  '--dt-colors-background-field-critical-disabled': '#e4e5eb80',
  '--dt-colors-background-field-critical-default': '#f8e1e100',
  '--dt-colors-background-field-critical-default-hover': '#f6d6d5',
  '--dt-colors-background-field-critical-default-active': '#f5cac9',
  '--dt-colors-background-field-critical-emphasized': '#f8e1e1',
  '--dt-colors-background-field-critical-emphasized-hover': '#f6d6d5',
  '--dt-colors-background-field-critical-emphasized-active': '#f5cac9',
  '--dt-colors-background-field-critical-accent': '#c62239',
  '--dt-colors-background-field-critical-accent-hover': '#b4002b',
  '--dt-colors-background-field-critical-accent-active': '#a2001d',
  '--dt-colors-background-shell-default': '#f2f2f5',
  '--dt-colors-box-shadow-default': '#2d2e4e',
  '--dt-colors-border-neutral-disabled': '#dadbe480',
  '--dt-colors-border-neutral-default': '#dadbe4',
  '--dt-colors-border-neutral-default-hover': '#d0d1dc',
  '--dt-colors-border-neutral-default-active': '#c6c7d5',
  '--dt-colors-border-neutral-accent': '#595a7d',
  '--dt-colors-border-neutral-accent-hover': '#434465',
  '--dt-colors-border-neutral-accent-active': '#2f2f4f',
  '--dt-colors-border-neutral-on-accent-disabled': '#f3f3f633',
  '--dt-colors-border-neutral-on-accent-default': '#f3f3f6',
  '--dt-colors-border-neutral-on-accent-default-hover': '#f3f3f6cc',
  '--dt-colors-border-neutral-on-accent-default-active': '#f3f3f699',
  '--dt-colors-border-neutral-subdued': '#e4e5eb',
  '--dt-colors-border-neutral-subdued-hover': '#d0d1dc',
  '--dt-colors-border-neutral-subdued-active': '#c6c7d5',
  '--dt-colors-border-primary-disabled': '#dadbe480',
  '--dt-colors-border-primary-default': '#d5dbf6',
  '--dt-colors-border-primary-default-hover': '#c9d1f4',
  '--dt-colors-border-primary-default-active': '#bdc7f2',
  '--dt-colors-border-primary-accent': '#464cce',
  '--dt-colors-border-primary-accent-hover': '#3431b3',
  '--dt-colors-border-primary-accent-active': '#250f98',
  '--dt-colors-border-primary-on-accent-disabled': '#f4f4fb33',
  '--dt-colors-border-primary-on-accent-default': '#f4f4fb',
  '--dt-colors-border-primary-on-accent-default-hover': '#f4f4fbcc',
  '--dt-colors-border-primary-on-accent-default-active': '#f4f4fb99',
  '--dt-colors-border-success-disabled': '#dadbe480',
  '--dt-colors-border-success-default': '#d3dedd',
  '--dt-colors-border-success-default-hover': '#c7d5d3',
  '--dt-colors-border-success-default-active': '#bbccc9',
  '--dt-colors-border-success-accent': '#2d6761',
  '--dt-colors-border-success-accent-hover': '#12504b',
  '--dt-colors-border-success-accent-active': '#003b36',
  '--dt-colors-border-success-on-accent-disabled': '#f1f4f433',
  '--dt-colors-border-success-on-accent-default': '#f1f4f4',
  '--dt-colors-border-success-on-accent-default-hover': '#f1f4f4cc',
  '--dt-colors-border-success-on-accent-default-active': '#f1f4f499',
  '--dt-colors-border-warning-disabled': '#dadbe480',
  '--dt-colors-border-warning-default': '#f9ebdb',
  '--dt-colors-border-warning-default-hover': '#f9e6d0',
  '--dt-colors-border-warning-default-active': '#f9e1c6',
  '--dt-colors-border-warning-accent': '#855400',
  '--dt-colors-border-warning-accent-hover': '#6d3d00',
  '--dt-colors-border-warning-accent-active': '#512a00',
  '--dt-colors-border-warning-on-accent-disabled': '#27202433',
  '--dt-colors-border-warning-on-accent-default': '#272024',
  '--dt-colors-border-warning-on-accent-default-hover': '#272024cc',
  '--dt-colors-border-warning-on-accent-default-active': '#27202499',
  '--dt-colors-border-critical-disabled': '#dadbe480',
  '--dt-colors-border-critical-default': '#f6d6d5',
  '--dt-colors-border-critical-default-hover': '#f5cac9',
  '--dt-colors-border-critical-default-active': '#f3bebd',
  '--dt-colors-border-critical-accent': '#bb0731',
  '--dt-colors-border-critical-accent-hover': '#9b001e',
  '--dt-colors-border-critical-accent-active': '#750013',
  '--dt-colors-border-critical-on-accent-disabled': '#f9f1f333',
  '--dt-colors-border-critical-on-accent-default': '#f9f1f3',
  '--dt-colors-border-critical-on-accent-default-hover': '#f9f1f3cc',
  '--dt-colors-border-critical-on-accent-default-active': '#f9f1f399',
  '--dt-colors-text-neutral-disabled': '#595a7d80',
  '--dt-colors-text-neutral-subdued': '#595a7d',
  '--dt-colors-text-neutral-subdued-hover': '#434465',
  '--dt-colors-text-neutral-subdued-active': '#2f2f4f',
  '--dt-colors-text-neutral-default': '#2f2f4f',
  '--dt-colors-text-neutral-default-hover': '#434465',
  '--dt-colors-text-neutral-default-active': '#595a7d',
  '--dt-colors-text-neutral-on-accent-disabled': '#f3f3f680',
  '--dt-colors-text-neutral-on-accent-default': '#f3f3f6',
  '--dt-colors-text-neutral-on-accent-default-hover': '#f3f3f6cc',
  '--dt-colors-text-neutral-on-accent-default-active': '#f3f3f699',
  '--dt-colors-text-primary-disabled': '#595a7d80',
  '--dt-colors-text-primary-default': '#464cce',
  '--dt-colors-text-primary-default-hover': '#3431b3',
  '--dt-colors-text-primary-default-active': '#250f98',
  '--dt-colors-text-primary-on-accent-disabled': '#f4f4fb80',
  '--dt-colors-text-primary-on-accent-default': '#f4f4fb',
  '--dt-colors-text-primary-on-accent-default-hover': '#f4f4fbcc',
  '--dt-colors-text-primary-on-accent-default-active': '#f4f4fb99',
  '--dt-colors-text-success-disabled': '#595a7d80',
  '--dt-colors-text-success-default': '#2d6761',
  '--dt-colors-text-success-default-hover': '#12504b',
  '--dt-colors-text-success-default-active': '#003b36',
  '--dt-colors-text-success-on-accent-disabled': '#f1f4f480',
  '--dt-colors-text-success-on-accent-default': '#f1f4f4',
  '--dt-colors-text-success-on-accent-default-hover': '#f1f4f4cc',
  '--dt-colors-text-success-on-accent-default-active': '#f1f4f499',
  '--dt-colors-text-warning-disabled': '#595a7d80',
  '--dt-colors-text-warning-default': '#855400',
  '--dt-colors-text-warning-default-hover': '#6d3d00',
  '--dt-colors-text-warning-default-active': '#512a00',
  '--dt-colors-text-warning-on-accent-disabled': '#27202480',
  '--dt-colors-text-warning-on-accent-default': '#272024',
  '--dt-colors-text-warning-on-accent-default-hover': '#272024cc',
  '--dt-colors-text-warning-on-accent-default-active': '#27202499',
  '--dt-colors-text-critical-disabled': '#595a7d80',
  '--dt-colors-text-critical-default': '#bb0731',
  '--dt-colors-text-critical-default-hover': '#9b001e',
  '--dt-colors-text-critical-default-active': '#750013',
  '--dt-colors-text-critical-on-accent-disabled': '#f9f1f380',
  '--dt-colors-text-critical-on-accent-default': '#f9f1f3',
  '--dt-colors-text-critical-on-accent-default-hover': '#f9f1f3cc',
  '--dt-colors-text-critical-on-accent-default-active': '#f9f1f399',
  '--dt-colors-icon-neutral-disabled': '#595a7d80',
  '--dt-colors-icon-neutral-subdued': '#595a7d',
  '--dt-colors-icon-neutral-subdued-hover': '#434465',
  '--dt-colors-icon-neutral-subdued-active': '#2f2f4f',
  '--dt-colors-icon-neutral-default': '#2f2f4f',
  '--dt-colors-icon-neutral-default-hover': '#434465',
  '--dt-colors-icon-neutral-default-active': '#595a7d',
  '--dt-colors-icon-neutral-on-accent-disabled': '#f3f3f680',
  '--dt-colors-icon-neutral-on-accent-default': '#f3f3f6',
  '--dt-colors-icon-neutral-on-accent-default-hover': '#f3f3f6cc',
  '--dt-colors-icon-neutral-on-accent-default-active': '#f3f3f699',
  '--dt-colors-icon-primary-disabled': '#595a7d80',
  '--dt-colors-icon-primary-default': '#464cce',
  '--dt-colors-icon-primary-default-hover': '#3431b3',
  '--dt-colors-icon-primary-default-active': '#250f98',
  '--dt-colors-icon-primary-on-accent-disabled': '#f4f4fb80',
  '--dt-colors-icon-primary-on-accent-default': '#f4f4fb',
  '--dt-colors-icon-primary-on-accent-default-hover': '#f4f4fbcc',
  '--dt-colors-icon-primary-on-accent-default-active': '#f4f4fb99',
  '--dt-colors-icon-success-disabled': '#595a7d80',
  '--dt-colors-icon-success-default': '#2d6761',
  '--dt-colors-icon-success-default-hover': '#12504b',
  '--dt-colors-icon-success-default-active': '#003b36',
  '--dt-colors-icon-success-on-accent-disabled': '#f1f4f480',
  '--dt-colors-icon-success-on-accent-default': '#f1f4f4',
  '--dt-colors-icon-success-on-accent-default-hover': '#f1f4f4cc',
  '--dt-colors-icon-success-on-accent-default-active': '#f1f4f499',
  '--dt-colors-icon-warning-disabled': '#595a7d80',
  '--dt-colors-icon-warning-default': '#855400',
  '--dt-colors-icon-warning-default-hover': '#6d3d00',
  '--dt-colors-icon-warning-default-active': '#512a00',
  '--dt-colors-icon-warning-on-accent-disabled': '#27202480',
  '--dt-colors-icon-warning-on-accent-default': '#272024',
  '--dt-colors-icon-warning-on-accent-default-hover': '#272024cc',
  '--dt-colors-icon-warning-on-accent-default-active': '#27202499',
  '--dt-colors-icon-critical-disabled': '#595a7d80',
  '--dt-colors-icon-critical-default': '#bb0731',
  '--dt-colors-icon-critical-default-hover': '#9b001e',
  '--dt-colors-icon-critical-default-active': '#750013',
  '--dt-colors-icon-critical-on-accent-disabled': '#f9f1f380',
  '--dt-colors-icon-critical-on-accent-default': '#f9f1f3',
  '--dt-colors-icon-critical-on-accent-default-hover': '#f9f1f3cc',
  '--dt-colors-icon-critical-on-accent-default-active': '#f9f1f399',
  '--dt-colors-syntax-comment': '#545586',
  '--dt-colors-syntax-string': '#086467',
  '--dt-colors-syntax-variable': '#2754b5',
  '--dt-colors-syntax-number': '#aa0081',
  '--dt-colors-syntax-punctuation': '#8136a9',
  '--dt-colors-syntax-function': '#2754b5',
  '--dt-colors-syntax-classname': '#2c2d4d',
  '--dt-colors-syntax-tag': '#b30926',
  '--dt-colors-syntax-operators': '#8136a9',
  '--dt-colors-syntax-boolean': '#973f00',
  '--dt-colors-theme-foreground-20': '#fff',
  '--dt-colors-theme-background-20': '#fff',
  '--dt-colors-background-surface-default': '#fff',
};

/**
 * Pre-refresh design token values — dark mode.
 */
export const classicDarkOverrides = {
  '--dt-box-shadows-surface-flat-rest': '0px 0px 0px 1px #f0f0f514',
  '--dt-box-shadows-surface-flat-hover':
    '0px 0px 0px 1px #f0f0f514, 0px 1px 2px #112, 0px 4px 8px #112c',
  '--dt-box-shadows-surface-flat-active': '0px 0px 0px 1px #f0f0f514',
  '--dt-box-shadows-surface-flat-drag':
    '0px 0px 0px 1px #f0f0f514, 0px 1px 2px #112, 0px 13px 8px #112c',
  '--dt-box-shadows-surface-raised-rest':
    '0px 0px 0px 1px #f0f0f514, 0px 1px 2px #112, 0px 4px 8px #112c',
  '--dt-box-shadows-surface-raised-hover':
    '0px 0px 0px 1px #f0f0f514, 0px 1px 2px #112, 0px 7px 8px #112c',
  '--dt-box-shadows-surface-raised-active':
    '0px 0px 0px 1px #f0f0f514, 0px 1px 2px #112, 0px 4px 8px #112c',
  '--dt-box-shadows-surface-raised-drag':
    '0px 0px 0px 1px #f0f0f514, 0px 1px 2px #112, 0px 13px 8px #112c',
  '--dt-box-shadows-surface-floating-rest':
    '0px 0px 0px 1px #f0f0f514, 0px 1px 2px #112, 0px 7px 8px #112c',
  '--dt-box-shadows-surface-floating-hover':
    '0px 0px 0px 1px #f0f0f514, 0px 1px 2px #112, 0px 10px 8px #112c',
  '--dt-box-shadows-surface-floating-active':
    '0px 0px 0px 1px #f0f0f514, 0px 1px 2px #112, 0px 7px 8px #112c',
  '--dt-box-shadows-surface-floating-drag':
    '0px 0px 0px 1px #f0f0f514, 0px 1px 2px #112, 0px 13px 8px #112c',
  '--dt-box-shadows-field-neutral-emphasized-rest':
    'inset 0px 0px 0px 1px #ebecff1f, inset 0px 1px 0px #ebecff14, 0px 1px 1px -1px #11112280, inset 0px 0px 0px 1px #112',
  '--dt-box-shadows-field-neutral-emphasized-hover':
    'inset 0px 0px 0px 1px #ebecff1f, inset 0px 1px 0px #ebecff14, 0px 1px 1px -1px #11112280, inset 0px 0px 0px 1px #3b3b52',
  '--dt-box-shadows-field-neutral-emphasized-active':
    'inset 0px 0px 0px 1px #ebecff1f, inset 0px 1px 0px #ebecff14, 0px 1px 1px -1px #11112280, inset 0px 0px 0px 1px #44445c',
  '--dt-box-shadows-field-neutral-accent':
    'inset 0px 0px 0px 1px #ffffff4d, inset 0px 1px 0px #ffffff8c, 0px 1px 1px -1px #f0f0f51f',
  '--dt-box-shadows-field-neutral-disabled':
    'inset 0px 0px 0px 1px #ebecff12, inset 0px 1px 0px #ebecff0a, 0px 1px 1px -1px #f0f0f51f',
  '--dt-box-shadows-field-primary-emphasized-rest':
    'inset 0px 0px 0px 1px #eef1ff0f, inset 0px 1px 0px #eef1ff1a, 0px 1px 1px -1px #11112280, inset 0px 0px 0px 1px #313150',
  '--dt-box-shadows-field-primary-emphasized-hover':
    'inset 0px 0px 0px 1px #eef1ff0f, inset 0px 1px 0px #eef1ff1a, 0px 1px 1px -1px #11112280, inset 0px 0px 0px 1px #39395d',
  '--dt-box-shadows-field-primary-emphasized-active':
    'inset 0px 0px 0px 1px #eef1ff0f, inset 0px 1px 0px #eef1ff1a, 0px 1px 1px -1px #11112280, inset 0px 0px 0px 1px #42426a',
  '--dt-box-shadows-field-primary-accent':
    'inset 0px 0px 0px 1px #eef1ff26, inset 0px 1px 0px #eef1ff40, 0px 1px 1px -1px #f0f0f51f',
  '--dt-box-shadows-field-primary-disabled':
    'inset 0px 0px 0px 1px #ebecff12, inset 0px 1px 0px #ebecff0a, 0px 1px 1px -1px #f0f0f51f',
  '--dt-box-shadows-field-success-emphasized-rest':
    'inset 0px 0px 0px 1px #aafef50f, inset 0px 1px 0px #aafef51a, 0px 1px 1px -1px #11112280, inset 0px 0px 0px 1px #273644',
  '--dt-box-shadows-field-success-emphasized-hover':
    'inset 0px 0px 0px 1px #aafef50f, inset 0px 1px 0px #aafef51a, 0px 1px 1px -1px #11112280, inset 0px 0px 0px 1px #2b404c',
  '--dt-box-shadows-field-success-emphasized-active':
    'inset 0px 0px 0px 1px #aafef50f, inset 0px 1px 0px #aafef51a, 0px 1px 1px -1px #11112280, inset 0px 0px 0px 1px #304a54',
  '--dt-box-shadows-field-success-accent':
    'inset 0px 0px 0px 1px #aafef533, inset 0px 1px 0px #aafef540, 0px 1px 1px -1px #f0f0f51f',
  '--dt-box-shadows-field-success-disabled':
    'inset 0px 0px 0px 1px #ebecff12, inset 0px 1px 0px #ebecff0a, 0px 1px 1px -1px #f0f0f51f',
  '--dt-box-shadows-field-warning-emphasized-rest':
    'inset 0px 0px 0px 1px #ffecc30f, inset 0px 1px 0px #ffecc31a, 0px 1px 1px -1px #11112280, inset 0px 0px 0px 1px #403537',
  '--dt-box-shadows-field-warning-emphasized-hover':
    'inset 0px 0px 0px 1px #ffecc30f, inset 0px 1px 0px #ffecc31a, 0px 1px 1px -1px #11112280, inset 0px 0px 0px 1px #4e3e39',
  '--dt-box-shadows-field-warning-emphasized-active':
    'inset 0px 0px 0px 1px #ffecc30f, inset 0px 1px 0px #ffecc31a, 0px 1px 1px -1px #11112280, inset 0px 0px 0px 1px #5d483c',
  '--dt-box-shadows-field-warning-accent':
    'inset 0px 0px 0px 1px #ffecc340, inset 0px 1px 0px #ffecc373, 0px 1px 1px -1px #f0f0f51f',
  '--dt-box-shadows-field-warning-disabled':
    'inset 0px 0px 0px 1px #ebecff12, inset 0px 1px 0px #ebecff0a, 0px 1px 1px -1px #f0f0f51f',
  '--dt-box-shadows-field-critical-emphasized-rest':
    'inset 0px 0px 0px 1px #ffeceb0f, inset 0px 1px 0px #ffeceb1a, 0px 1px 1px -1px #11112280, inset 0px 0px 0px 1px #3c2131',
  '--dt-box-shadows-field-critical-emphasized-hover':
    'inset 0px 0px 0px 1px #ffeceb0f, inset 0px 1px 0px #ffeceb1a, 0px 1px 1px -1px #11112280, inset 0px 0px 0px 1px #482332',
  '--dt-box-shadows-field-critical-emphasized-active':
    'inset 0px 0px 0px 1px #ffeceb0f, inset 0px 1px 0px #ffeceb1a, 0px 1px 1px -1px #11112280, inset 0px 0px 0px 1px #542433',
  '--dt-box-shadows-field-critical-accent':
    'inset 0px 0px 0px 1px #ffeceb33, inset 0px 1px 0px #ffeceb40, 0px 1px 1px -1px #f0f0f51f',
  '--dt-box-shadows-field-critical-disabled':
    'inset 0px 0px 0px 1px #ebecff12, inset 0px 1px 0px #ebecff0a, 0px 1px 1px -1px #f0f0f51f',
  '--dt-colors-theme-foreground-10': '#f0f0f5',
  '--dt-colors-theme-background-10': '#19192c',
  '--dt-colors-theme-background-shell-default': '#141419',
  '--dt-colors-theme-background-surface-backdrop-embedded': '#112c',
  '--dt-colors-theme-neutral-10': '#212135',
  '--dt-colors-theme-neutral-20': '#292a3e',
  '--dt-colors-theme-neutral-30': '#323248',
  '--dt-colors-theme-neutral-40': '#3b3b52',
  '--dt-colors-theme-neutral-50': '#44445c',
  '--dt-colors-theme-neutral-60': '#4d4e66',
  '--dt-colors-theme-neutral-70': '#a0a1c0',
  '--dt-colors-theme-neutral-80': '#b0b1d0',
  '--dt-colors-theme-neutral-90': '#bfc0e1',
  '--dt-colors-theme-primary-10': '#212138',
  '--dt-colors-theme-primary-20': '#292944',
  '--dt-colors-theme-primary-30': '#313150',
  '--dt-colors-theme-primary-40': '#39395d',
  '--dt-colors-theme-primary-50': '#42426a',
  '--dt-colors-theme-primary-60': '#4a4b78',
  '--dt-colors-theme-primary-70': '#999bed',
  '--dt-colors-theme-primary-80': '#a8abfe',
  '--dt-colors-theme-primary-90': '#b8bbff',
  '--dt-colors-theme-success-10': '#1e2234',
  '--dt-colors-theme-success-20': '#222c3c',
  '--dt-colors-theme-success-30': '#273644',
  '--dt-colors-theme-success-40': '#2b404c',
  '--dt-colors-theme-success-50': '#304a54',
  '--dt-colors-theme-success-60': '#34545d',
  '--dt-colors-theme-success-70': '#5eb1a9',
  '--dt-colors-theme-success-80': '#6ec1b9',
  '--dt-colors-theme-success-90': '#7ed1c9',
  '--dt-colors-theme-warning-10': '#252230',
  '--dt-colors-theme-warning-20': '#332c34',
  '--dt-colors-theme-warning-30': '#403537',
  '--dt-colors-theme-warning-40': '#4e3e39',
  '--dt-colors-theme-warning-50': '#5d483c',
  '--dt-colors-theme-warning-60': '#6c523e',
  '--dt-colors-theme-warning-70': '#eea746',
  '--dt-colors-theme-warning-80': '#ffb758',
  '--dt-colors-theme-warning-90': '#ffc974',
  '--dt-colors-theme-critical-10': '#251c2e',
  '--dt-colors-theme-critical-20': '#301f2f',
  '--dt-colors-theme-critical-30': '#3c2131',
  '--dt-colors-theme-critical-40': '#482332',
  '--dt-colors-theme-critical-50': '#542433',
  '--dt-colors-theme-critical-60': '#602634',
  '--dt-colors-theme-critical-70': '#c82d40',
  '--dt-colors-theme-critical-80': '#b61532',
  '--dt-colors-theme-critical-90': '#a50024',
  '--dt-colors-background-base-default': '#19192c',
  '--dt-colors-background-surface-backdrop': '#19192ccc',
  '--dt-colors-background-surface-backdrop-embedded': '#112c',
  '--dt-colors-background-container-neutral-subdued': '#19192c',
  '--dt-colors-background-container-neutral-default': '#212135',
  '--dt-colors-background-container-neutral-emphasized': '#292a3e',
  '--dt-colors-background-container-neutral-accent': '#a0a1c0',
  '--dt-colors-background-container-primary-default': '#212138',
  '--dt-colors-background-container-primary-emphasized': '#292944',
  '--dt-colors-background-container-primary-accent': '#999bed',
  '--dt-colors-background-container-success-default': '#1e2234',
  '--dt-colors-background-container-success-emphasized': '#222c3c',
  '--dt-colors-background-container-success-accent': '#5eb1a9',
  '--dt-colors-background-container-warning-default': '#252230',
  '--dt-colors-background-container-warning-emphasized': '#332c34',
  '--dt-colors-background-container-warning-accent': '#eea746',
  '--dt-colors-background-container-critical-default': '#251c2e',
  '--dt-colors-background-container-critical-emphasized': '#301f2f',
  '--dt-colors-background-container-critical-accent': '#c82d40',
  '--dt-colors-background-field-neutral-disabled': '#32324880',
  '--dt-colors-background-field-neutral-default': '#32324800',
  '--dt-colors-background-field-neutral-default-hover': '#3b3b52',
  '--dt-colors-background-field-neutral-default-active': '#44445c',
  '--dt-colors-background-field-neutral-emphasized': '#323248',
  '--dt-colors-background-field-neutral-emphasized-hover': '#3b3b52',
  '--dt-colors-background-field-neutral-emphasized-active': '#44445c',
  '--dt-colors-background-field-neutral-accent': '#a0a1c0',
  '--dt-colors-background-field-neutral-accent-hover': '#b0b1d0',
  '--dt-colors-background-field-neutral-accent-active': '#bfc0e1',
  '--dt-colors-background-field-primary-disabled': '#32324880',
  '--dt-colors-background-field-primary-default': '#31315000',
  '--dt-colors-background-field-primary-default-hover': '#39395d',
  '--dt-colors-background-field-primary-default-active': '#42426a',
  '--dt-colors-background-field-primary-emphasized': '#313150',
  '--dt-colors-background-field-primary-emphasized-hover': '#39395d',
  '--dt-colors-background-field-primary-emphasized-active': '#42426a',
  '--dt-colors-background-field-primary-accent': '#999bed',
  '--dt-colors-background-field-primary-accent-hover': '#a8abfe',
  '--dt-colors-background-field-primary-accent-active': '#b8bbff',
  '--dt-colors-background-field-success-disabled': '#32324880',
  '--dt-colors-background-field-success-default': '#27364400',
  '--dt-colors-background-field-success-default-hover': '#2b404c',
  '--dt-colors-background-field-success-default-active': '#304a54',
  '--dt-colors-background-field-success-emphasized': '#273644',
  '--dt-colors-background-field-success-emphasized-hover': '#2b404c',
  '--dt-colors-background-field-success-emphasized-active': '#304a54',
  '--dt-colors-background-field-success-accent': '#5eb1a9',
  '--dt-colors-background-field-success-accent-hover': '#6ec1b9',
  '--dt-colors-background-field-success-accent-active': '#7ed1c9',
  '--dt-colors-background-field-warning-disabled': '#32324880',
  '--dt-colors-background-field-warning-default': '#40353700',
  '--dt-colors-background-field-warning-default-hover': '#4e3e39',
  '--dt-colors-background-field-warning-default-active': '#5d483c',
  '--dt-colors-background-field-warning-emphasized': '#403537',
  '--dt-colors-background-field-warning-emphasized-hover': '#4e3e39',
  '--dt-colors-background-field-warning-emphasized-active': '#5d483c',
  '--dt-colors-background-field-warning-accent': '#eea746',
  '--dt-colors-background-field-warning-accent-hover': '#ffb758',
  '--dt-colors-background-field-warning-accent-active': '#ffc974',
  '--dt-colors-background-field-critical-disabled': '#32324880',
  '--dt-colors-background-field-critical-default': '#3c213100',
  '--dt-colors-background-field-critical-default-hover': '#482332',
  '--dt-colors-background-field-critical-default-active': '#542433',
  '--dt-colors-background-field-critical-emphasized': '#3c2131',
  '--dt-colors-background-field-critical-emphasized-hover': '#482332',
  '--dt-colors-background-field-critical-emphasized-active': '#542433',
  '--dt-colors-background-field-critical-accent': '#c82d40',
  '--dt-colors-background-field-critical-accent-hover': '#b61532',
  '--dt-colors-background-field-critical-accent-active': '#a50024',
  '--dt-colors-background-shell-default': '#141419',
  '--dt-colors-box-shadow-default': '#112',
  '--dt-colors-border-neutral-disabled': '#3b3b5280',
  '--dt-colors-border-neutral-default': '#3b3b52',
  '--dt-colors-border-neutral-default-hover': '#44445c',
  '--dt-colors-border-neutral-default-active': '#4d4e66',
  '--dt-colors-border-neutral-accent': '#b1b2d2',
  '--dt-colors-border-neutral-accent-hover': '#cecff0',
  '--dt-colors-border-neutral-accent-active': '#ebecff',
  '--dt-colors-border-neutral-on-accent-disabled': '#1f203333',
  '--dt-colors-border-neutral-on-accent-default': '#1f2033',
  '--dt-colors-border-neutral-on-accent-default-hover': '#1f2033cc',
  '--dt-colors-border-neutral-on-accent-default-active': '#1f203399',
  '--dt-colors-border-neutral-subdued': '#323248',
  '--dt-colors-border-neutral-subdued-hover': '#44445c',
  '--dt-colors-border-neutral-subdued-active': '#4d4e66',
  '--dt-colors-border-primary-disabled': '#3b3b5280',
  '--dt-colors-border-primary-default': '#39395d',
  '--dt-colors-border-primary-default-hover': '#42426a',
  '--dt-colors-border-primary-default-active': '#4a4b78',
  '--dt-colors-border-primary-accent': '#adb0ff',
  '--dt-colors-border-primary-accent-hover': '#ccd0ff',
  '--dt-colors-border-primary-accent-active': '#eef1ff',
  '--dt-colors-border-primary-on-accent-disabled': '#1f203733',
  '--dt-colors-border-primary-on-accent-default': '#1f2037',
  '--dt-colors-border-primary-on-accent-default-hover': '#1f2037cc',
  '--dt-colors-border-primary-on-accent-default-active': '#1f203799',
  '--dt-colors-border-success-disabled': '#3b3b5280',
  '--dt-colors-border-success-default': '#2b404c',
  '--dt-colors-border-success-default-hover': '#304a54',
  '--dt-colors-border-success-default-active': '#34545d',
  '--dt-colors-border-success-accent': '#6fc3ba',
  '--dt-colors-border-success-accent-hover': '#8ce0d7',
  '--dt-colors-border-success-accent-active': '#aafef5',
  '--dt-colors-border-success-on-accent-disabled': '#1a233233',
  '--dt-colors-border-success-on-accent-default': '#1a2332',
  '--dt-colors-border-success-on-accent-default-hover': '#1a2332cc',
  '--dt-colors-border-success-on-accent-default-active': '#1a233299',
  '--dt-colors-border-warning-disabled': '#3b3b5280',
  '--dt-colors-border-warning-default': '#4e3e39',
  '--dt-colors-border-warning-default-hover': '#5d483c',
  '--dt-colors-border-warning-default-active': '#6c523e',
  '--dt-colors-border-warning-accent': '#eea83f',
  '--dt-colors-border-warning-accent-hover': '#ffc563',
  '--dt-colors-border-warning-accent-active': '#ffecc3',
  '--dt-colors-border-warning-on-accent-disabled': '#27212633',
  '--dt-colors-border-warning-on-accent-default': '#272126',
  '--dt-colors-border-warning-on-accent-default-hover': '#272126cc',
  '--dt-colors-border-warning-on-accent-default-active': '#27212699',
  '--dt-colors-border-critical-disabled': '#3b3b5280',
  '--dt-colors-border-critical-default': '#482332',
  '--dt-colors-border-critical-default-hover': '#542433',
  '--dt-colors-border-critical-default-active': '#602634',
  '--dt-colors-border-critical-accent': '#ff999c',
  '--dt-colors-border-critical-accent-hover': '#ffc1c1',
  '--dt-colors-border-critical-accent-active': '#ffeceb',
  '--dt-colors-border-critical-on-accent-disabled': '#f9f1f333',
  '--dt-colors-border-critical-on-accent-default': '#f9f1f3',
  '--dt-colors-border-critical-on-accent-default-hover': '#f9f1f3cc',
  '--dt-colors-border-critical-on-accent-default-active': '#f9f1f399',
  '--dt-colors-text-neutral-disabled': '#b1b2d280',
  '--dt-colors-text-neutral-subdued': '#b1b2d2',
  '--dt-colors-text-neutral-subdued-hover': '#cecff0',
  '--dt-colors-text-neutral-subdued-active': '#ebecff',
  '--dt-colors-text-neutral-default': '#ebecff',
  '--dt-colors-text-neutral-default-hover': '#cecff0',
  '--dt-colors-text-neutral-default-active': '#b1b2d2',
  '--dt-colors-text-neutral-on-accent-disabled': '#1f203380',
  '--dt-colors-text-neutral-on-accent-default': '#1f2033',
  '--dt-colors-text-neutral-on-accent-default-hover': '#1f2033cc',
  '--dt-colors-text-neutral-on-accent-default-active': '#1f203399',
  '--dt-colors-text-primary-disabled': '#b1b2d280',
  '--dt-colors-text-primary-default': '#adb0ff',
  '--dt-colors-text-primary-default-hover': '#ccd0ff',
  '--dt-colors-text-primary-default-active': '#eef1ff',
  '--dt-colors-text-primary-on-accent-disabled': '#1f203780',
  '--dt-colors-text-primary-on-accent-default': '#1f2037',
  '--dt-colors-text-primary-on-accent-default-hover': '#1f2037cc',
  '--dt-colors-text-primary-on-accent-default-active': '#1f203799',
  '--dt-colors-text-success-disabled': '#b1b2d280',
  '--dt-colors-text-success-default': '#6fc3ba',
  '--dt-colors-text-success-default-hover': '#8ce0d7',
  '--dt-colors-text-success-default-active': '#aafef5',
  '--dt-colors-text-success-on-accent-disabled': '#1a233280',
  '--dt-colors-text-success-on-accent-default': '#1a2332',
  '--dt-colors-text-success-on-accent-default-hover': '#1a2332cc',
  '--dt-colors-text-success-on-accent-default-active': '#1a233299',
  '--dt-colors-text-warning-disabled': '#b1b2d280',
  '--dt-colors-text-warning-default': '#eea83f',
  '--dt-colors-text-warning-default-hover': '#ffc563',
  '--dt-colors-text-warning-default-active': '#ffecc3',
  '--dt-colors-text-warning-on-accent-disabled': '#27212680',
  '--dt-colors-text-warning-on-accent-default': '#272126',
  '--dt-colors-text-warning-on-accent-default-hover': '#272126cc',
  '--dt-colors-text-warning-on-accent-default-active': '#27212699',
  '--dt-colors-text-critical-disabled': '#b1b2d280',
  '--dt-colors-text-critical-default': '#ff999c',
  '--dt-colors-text-critical-default-hover': '#ffc1c1',
  '--dt-colors-text-critical-default-active': '#ffeceb',
  '--dt-colors-text-critical-on-accent-disabled': '#f9f1f380',
  '--dt-colors-text-critical-on-accent-default': '#f9f1f3',
  '--dt-colors-text-critical-on-accent-default-hover': '#f9f1f3cc',
  '--dt-colors-text-critical-on-accent-default-active': '#f9f1f399',
  '--dt-colors-icon-neutral-disabled': '#b1b2d280',
  '--dt-colors-icon-neutral-subdued': '#b1b2d2',
  '--dt-colors-icon-neutral-subdued-hover': '#cecff0',
  '--dt-colors-icon-neutral-subdued-active': '#ebecff',
  '--dt-colors-icon-neutral-default': '#ebecff',
  '--dt-colors-icon-neutral-default-hover': '#cecff0',
  '--dt-colors-icon-neutral-default-active': '#b1b2d2',
  '--dt-colors-icon-neutral-on-accent-disabled': '#1f203380',
  '--dt-colors-icon-neutral-on-accent-default': '#1f2033',
  '--dt-colors-icon-neutral-on-accent-default-hover': '#1f2033cc',
  '--dt-colors-icon-neutral-on-accent-default-active': '#1f203399',
  '--dt-colors-icon-primary-disabled': '#b1b2d280',
  '--dt-colors-icon-primary-default': '#adb0ff',
  '--dt-colors-icon-primary-default-hover': '#ccd0ff',
  '--dt-colors-icon-primary-default-active': '#eef1ff',
  '--dt-colors-icon-primary-on-accent-disabled': '#1f203780',
  '--dt-colors-icon-primary-on-accent-default': '#1f2037',
  '--dt-colors-icon-primary-on-accent-default-hover': '#1f2037cc',
  '--dt-colors-icon-primary-on-accent-default-active': '#1f203799',
  '--dt-colors-icon-success-disabled': '#b1b2d280',
  '--dt-colors-icon-success-default': '#6fc3ba',
  '--dt-colors-icon-success-default-hover': '#8ce0d7',
  '--dt-colors-icon-success-default-active': '#aafef5',
  '--dt-colors-icon-success-on-accent-disabled': '#1a233280',
  '--dt-colors-icon-success-on-accent-default': '#1a2332',
  '--dt-colors-icon-success-on-accent-default-hover': '#1a2332cc',
  '--dt-colors-icon-success-on-accent-default-active': '#1a233299',
  '--dt-colors-icon-warning-disabled': '#b1b2d280',
  '--dt-colors-icon-warning-default': '#eea83f',
  '--dt-colors-icon-warning-default-hover': '#ffc563',
  '--dt-colors-icon-warning-default-active': '#ffecc3',
  '--dt-colors-icon-warning-on-accent-disabled': '#27212680',
  '--dt-colors-icon-warning-on-accent-default': '#272126',
  '--dt-colors-icon-warning-on-accent-default-hover': '#272126cc',
  '--dt-colors-icon-warning-on-accent-default-active': '#27212699',
  '--dt-colors-icon-critical-disabled': '#b1b2d280',
  '--dt-colors-icon-critical-default': '#ff999c',
  '--dt-colors-icon-critical-default-hover': '#ffc1c1',
  '--dt-colors-icon-critical-default-active': '#ffeceb',
  '--dt-colors-icon-critical-on-accent-disabled': '#f9f1f380',
  '--dt-colors-icon-critical-on-accent-default': '#f9f1f3',
  '--dt-colors-icon-critical-on-accent-default-hover': '#f9f1f3cc',
  '--dt-colors-icon-critical-on-accent-default-active': '#f9f1f399',
  '--dt-colors-syntax-comment': '#b2b3cd',
  '--dt-colors-syntax-string': '#80dbca',
  '--dt-colors-syntax-variable': '#abb1ed',
  '--dt-colors-syntax-number': '#fd8fe1',
  '--dt-colors-syntax-punctuation': '#cfa3f3',
  '--dt-colors-syntax-function': '#abb1ed',
  '--dt-colors-syntax-classname': '#f0f0f5',
  '--dt-colors-syntax-tag': '#ff96a6',
  '--dt-colors-syntax-operators': '#cfa3f3',
  '--dt-colors-syntax-boolean': '#fe9b7d',
  '--dt-colors-theme-foreground-20': '#112',
  '--dt-colors-theme-background-20': '#112',
  '--dt-colors-background-surface-default': '#112',
};
